<template lang="pug">
modal.checkbox-settings-modal(
  :close-button-label='$t("button.cancel")'
  :disable-process-button='invalidForm'
  :process-button-label='$t("button.save")'
  :title='$t("modal.comment_settings.title")'
  @opened='onOpenModal'
  @process='process'
  ref='modal'
  size='sm'
)
  .col-12(v-if='element')
    form.needs-validation(novalidate)
      .form-group.mb-0
        label(for='field-comment-value') {{ $t('modal.comment_settings.instruction') }}
        textarea#field-comment-value.mt-0.form-control(
          :placeholder='$t("modal.comment_settings.placeholder")'
          @blur='validate'
          @input='validate'
          maxlength='100'
          required
          rows='3'
          style='min-height: 80px'
          v-model='element.value'
        )
        .invalid-feedback {{ $t('modal.comment_settings.invalid_feedback') }}
</template>
<script>
import Icon from '@/ui/atoms/Icon.vue';
import Modal from '@/ui/molecules/Modal.vue';

export default {
  components: {
    Modal,
    Icon,
  },
  data() {
    return {
      element: {},
      invalidForm: true,
    };
  },
  methods: {
    onOpenModal() {
      this.validate();
      if (!this.element.value) {
        window
          .jQuery('#field-comment-value')
          .removeClass('is-valid')
          .removeClass('is-invalid');
      }
    },
    process() {
      this.element.textLines = this.element.value.split('\n').length;
      this.$emit('settings', this.element);
      this.$refs.modal.close();
    },
    validate() {
      if (this.element.value) {
        this.invalidForm = false;
      } else {
        this.invalidForm = true;
      }
    },
  },
};
</script>
<style lang="stylus">
.checkbox-settings-modal
  .form-check.form-switch
    .form-check-label
      margin: .2rem 0 0 .5rem
</style>
